// src/features/dashboard/services/timeAllocationChartApi.ts

import api
from '../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../api/endpoints';

import type {

  TimeAllocationChartApiResponse,

  TimeAllocationChartRequest,

} from '../types/timeAllocationChart.types';

/**
 * =========================================
 * GET TIME ALLOCATION CHART
 * =========================================
 */
export const getTimeAllocationChart =
  async (
    payload:
      TimeAllocationChartRequest,
  ):
    Promise<
      TimeAllocationChartApiResponse[]
    > => {

    const response =
      await api.post(
        ENDPOINTS.SPAN_TIME_ALLOCATION,
        payload,
      );

    return response.data;
  };